import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export const LanguageResource = () => {
  return Vue.resource('languages{/id}')
}



// WEBPACK FOOTER //
// ./src/api/language.js